/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommAnnualReportsViewProps } from './ecomm-annual-reports';

export class EcommAnnualReportsView extends React.PureComponent<IEcommAnnualReportsViewProps> {
  public render(): JSX.Element | null {
    const { reports, ebook } = this.props;

    return (
      <div className='ecomm-annual-reports row'>
        <div className='report-navi col-4'>
          {reports && reports.map((item, index) =>
            <div key={index}>{item}</div>
          )}
        </div>
        <div className='report-display col-8'>
          <iframe src={ebook} />
        </div>
      </div>
    );
  }
}

export default EcommAnnualReportsView;